module.exports = __webpack_public_path__ + "img/button-crosstown.6138c565.png";